import React from 'react';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import { injectIntl, IntlShape } from 'react-intl';

import { AssuranceIcon } from 'images';

import { OrangeButton } from 'components/Button';
import { uppercase } from 'utils/string';
import messages from 'containers/AgentPage/messages';
import { translate } from 'helpers/intl';
import {
  StyledSmallSectionHeader,
  StyledCaptions,
} from 'components/AgentInfo/HeaderAgentInfo/style';
import { useMediaQuery, useTheme } from '@material-ui/core';

const HeaderAgentInfo = (props: {
  intl: IntlShape;
  nameAgent: string;
  AdresseAgent: string;
  villeAgent: string;
  lat: number;
  lng: number;
}) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Box pr={3} py={2.5}>
      <Grid container>
        <Grid item xs={11}>
          <StyledSmallSectionHeader color="#0880BC" weight="500">
            {uppercase(props.nameAgent)}
          </StyledSmallSectionHeader>
          <StyledCaptions weight="400">
            {uppercase(props.AdresseAgent)}
            {','}
            {uppercase(props.villeAgent)}
          </StyledCaptions>
          <Grid item xs={matches ? 12 : 3}>
            <OrangeButton
              variant="contained"
              onClick={
                /* istanbul ignore next */ () =>
                  window.open(
                    'https://maps.google.com?q=' + props.lat + ',' + props.lng,
                  )
              }
            >
              <Grid container spacing={3}>
                <Grid item xs={1}>
                  <img alt="" src={AssuranceIcon['ItineraireIcon']} />
                </Grid>
                <Grid item xs={8}>
                  {translate({ ...messages.buttonItineraire }, props)}
                </Grid>
              </Grid>
            </OrangeButton>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default injectIntl(HeaderAgentInfo);
